import { IJWTPayload } from "~/interfaces/IJWTPayload";

export const isJWTPayload = (x: unknown): x is IJWTPayload => x instanceof Object && "skyfax" in x && typeof x["skyfax"] === "string"